export const formatDuration = (duration) => {
  const hours = Math.floor(duration / 3600);
  const minutes = Math.floor((duration % 3600) / 60);
  const seconds = Math.floor(duration % 60);

  return `${hours > 0 ? `${hours} ساعت ` : ""}${
    minutes > 0 ? `${minutes} دقیقه ` : ""
  }${seconds} ثانیه`;
};
